import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { PreferredMimeType } from '../services/backendService/types';
import { useMetrics } from './useMetrics';
import useRouterMatch from './useRouterMatch';

export const useUploadGoogleDrive = (activeTenantId: string) => {
  const client = useQueryClient();
  const metrics = useMetrics();
  const { templateId } = useRouterMatch();
  const {
    mutate: upload,
    isError,
    isPending: isLoading,
    isSuccess,
    reset,
    data,
  } = useMutation({
    mutationFn: async ({
      fileId,
      preferredMimeType,
    }: {
      fileId: string;
      preferredMimeType?: PreferredMimeType;
      onSuccessFunction?: () => void;
    }) => {
      const {
        fileUploadId,
        filePath,
        fileType,
      } = await BackendService.instance.integrations.googleDrive.copyFileToBucket(
        fileId,
        activeTenantId,
        preferredMimeType,
      );
      return { fileUploadId, filePath, fileType };
    },

    onSuccess: (data, { onSuccessFunction }) => {
      if (onSuccessFunction) {
        onSuccessFunction();
      }
      const templateCacheKey = ['template', templateId];
      client.invalidateQueries({
        queryKey: templateCacheKey,
      });
      metrics.logEvent('Creator.Upload.GoogleDrive.Generator.Success', { templateId });
    },
  });

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    isError,
    fileInfo: data,
    reset,
  };
};
